import '../../../scss/app/blog_post.scss';
